<template>
	<div>
		<a-button style="margin-top: 10px;margin-bottom: 20px;" @click="showDrawer()" type="primary">
			<a-icon type="plus" />
			添加广告
		</a-button>

		<a-table :columns="columns" :data-source="data" bordered>
			<span slot="cover" slot-scope="text, record"><img style="width: 80px;" :src="text" alt="" /></span>
			<span slot="display" slot-scope="text, record"><a-switch :defaultChecked="text" /></span>
			<span slot="operation" slot-scope="text, record">
				<!-- <a>编辑</a>
				<a-divider type="vertical" />
				-->
				<a-popconfirm
					title="此操作将删除该广告,是否删除？"
					@confirm="deleteContent(record.id)"
					okText="删除"
					cancelText="取消"
				>
					<a-button type="link">
					删除
					</a-button>
				</a-popconfirm>
				
			</span>
		</a-table>

		<a-drawer title="添加广告" placement="right" :closable="false" :visible="visible" @close="onClose" :width="800">
			<a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="广告名称"><a-input v-model="advertisingName" placeholder="广告名称" /></a-form-model-item>
				<a-form-model-item label="广告图片">
					<a-upload
						:action="domain"
						:data="QiniuData"
						:beforeUpload="beforeAvatarUpload"
						listType="picture-card"
						:fileList="bannerList"
						@preview="handlePreview"
						:remove="bannerRemove"
					>
						<div v-if="bannerList.length < 1">
							<a-icon type="plus" />
							<div class="ant-upload-text">广告图</div>
						</div>
					</a-upload>
					<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel"><img alt="example" style="width: 100%" :src="previewImage" /></a-modal>
				</a-form-model-item>
				<!-- <a-form-model-item label="上线/下线"><a-switch :defaultChecked="display" /></a-form-model-item> -->
				<a-form-model-item label="链接商品">
					<a-button type="link" @click="showModal()">选择商品</a-button>
					{{ selectProductName }}
				</a-form-model-item>

				<div style="margin-left: 50px;margin-top: 50px;">
					<a-button type="primary" @click="submitContent">保存</a-button>
					<a-divider type="vertical" />
					<a-button @click="closeModle">取消</a-button>
				</div>
			</a-form-model>
		</a-drawer>

		<a-modal :width="900" v-model="selectProduct" title="商品列表" ok-text="确认" cancel-text="取消" @ok="handleOk" @cancel="cancel">
			<div>
				<a-form-model-item>
					<a-input style="width: 200px;margin-right: 20px;" v-model="productName" placeholder="商品名称">
						<a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
					</a-input>
					<a-button type="primary" @click="searchHandle" icon="search">搜索</a-button>
				</a-form-model-item>
			</div>

			<a-table
				:columns="productColumns"
				:data-source="productList"
				:pagination="pagination"
				@change="handleTableChange"
				:row-selection="{ type: 'radio', onChange: selectProject }"
				bordered
			>
				<img slot="productPic" style="max-width: 60px;max-height: 60px;" slot-scope="text" :src="text.productPic[0]" alt="" />
			</a-table>
		</a-modal>
	</div>
</template>
<script>
const columns = [
	{
		dataIndex: 'advertisingName',
		key: 'advertisingName',
		title: '广告名称'
	},
	{
		title: '商品名称',
		dataIndex: 'productName',
		key: 'productName'
	},
	{
		title: '广告图片',
		dataIndex: 'cover',
		key: 'cover',
		scopedSlots: { customRender: 'cover' }
	},
	{
		title: '添加时间',
		dataIndex: 'dateTime',
		key: 'dateTime'
	},
	// {
	// 	title: '上线/下线',
	// 	key: 'display',
	// 	dataIndex: 'display',
	// 	scopedSlots: { customRender: 'display' }
	// },
	{ title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

const productColumns = [
	{ title: '商品名称', width: '250px', dataIndex: 'productName', key: 'productName' },
	{ title: '商品图片', width: '200px', key: 'productPic', scopedSlots: { customRender: 'productPic' } },
	{ title: '添加时间', dataIndex: 'indate', key: 'indate' }
];
const productList = []


import api from '../../../api/Api.js';
import axios from 'axios';

export default {
	data() {
		return {
			data: [],
			columns,
			productColumns,
			productList: productList,
			page: 0,
			pagination: { current: 0, pageSize: 5, total: 10 },
			visible: false,
			labelCol: { span: 4 },
			wrapperCol: { span: 14 },
			advertisingName: '',
			display: '',
			QiniuData: {
				key: '', //图片名字处理
				token: '' //七牛云token
			},
			domain: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			qiniuaddr: 'http://cdn.diqwl.com', // 七牛云的图片外链地址
			bannerList: [],
			previewImage: '',
			previewVisible: false,
			selectProduct: false,
			productName:'',
			selectProductName: '暂无商品',
			productId: 0
		};
	},
	mounted() {
		this.getProductEvaluate();
		this.getQiniuToken();
		this.getCommodityList();
	},
	methods: {
		submitContent(){
			
			if(this.advertisingName == "" || this.bannerList.length == 0 || this.productId == 0){
				this.$message.warning("资料不完善，无法保存")
				return;
			}
			
			const that = this;
			let url = 'api/store/v1/admin/market/addAdvertising';
			let param = {
				advertisingName: this.advertisingName,
				cover: this.bannerList[0].url,
				productId: this.productId
			};
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					console.log(res)
					that.visible = false;
					that.selectProduct = false;
					this.getProductEvaluate()
				}
			});
		},
		deleteContent(id){
			
			const that = this;
			let url = 'api/store/v1/admin/market/deleteAdvertising';
			let param = {
				id: id
			};
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					this.$message.success("删除成功！")
					this.getProductEvaluate()
				}
			});
		},
		getProductEvaluate() {
			const that = this;
			let url = 'api/store/v1/admin/market/coverList';
			let param = 1;
			api.postRequest(url, param, res => {
				if (res.status == 200) {
					that.data = res.data.data;
					that.data.forEach((item, index, array) => {
						item.display = this.numberToBool(item.display);
						item.key = index;
					});
					console.log(that.data);
				}
			});
		},
		getCommodityList() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/advertisingCommodityList';
			let param = {
				page: this.page,
				productName: this.productName
			};
			api.postRequest(url, param, res => {
				console.log(res.data.maxCount)
				if (res.status == 200) {
					that.productList = res.data.data;
					this.pagination.total = res.data.maxCount;
					that.productList.forEach((item, index, array) => {
						item.key = item.productId;
					});
				}
			});
		},
		selectProject(selectedRowKeys, selectedRows){
			this.selectProductName = selectedRows[0].productName;
			this.productId = selectedRows[0].productId;
		},
		searchHandle(){
			this.getCommodityList();
		},
		handleTableChange(pagination, filters, sorter) {
			this.pagination = pagination;
			this.page = this.pagination.current - 1;
			this.getCommodityList();
		},
		numberToBool(number) {
			if (number == 0) {
				return true;
			} else {
				return false;
			}
		},
		showDrawer() {
			if(this.data.length >= 5){
				this.$message.warning("只能添加五条广告")
				return;
			}
			this.visible = true;
		},
		showModal() {
			this.productName = '';
			this.getCommodityList()
			this.selectProduct = true;
		},
		handleOk(e) {
			this.selectProduct = false;
		},
		beforeAvatarUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;

			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;

			this.bannerList.push(obj);
		},
		handlePreview(file) {
			this.previewImage = file.url || file.thumbUrl;
			this.previewVisible = true;
		},
		bannerRemove(file) {
			var index = this.bannerList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.bannerList.splice(index, 1);
		},
		//请求后台拿七牛云token
		getQiniuToken() {
			const that = this;
			let url = 'api/file/v1/qiniu/getToken';
			let parm = 1;
			
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.QiniuData.token = res.data.data.token;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		handleCancel() {
			this.previewVisible = false;
		},

		onClose() {
			this.visible = false;
		},
		cancel(){
			this.selectProductName = '暂无商品';
			this.productId = 0;
		},
		closeModle(){
			this.visible = false;
		}
	}
};
</script>
